// Convert object to query string using URLSearchParams
export function toQueryString(data: Record<string, string>): string {
  const params = new URLSearchParams()
  Object.entries(data).forEach(([key, value]) => {
    params.append(key, value)
  })
  return params.toString()
}

// JSONP implementation
export function jsonp<T extends Record<string, string>>(
  url: string,
  options: { param: string },
  callback: (err: Error | null, data?: T) => void,
): void {
  const callbackName = `jsonp_callback_${Date.now()}_${Math.round(Math.random() * 100000)}`
  const script = document.createElement('script')

  // Create global callback function
  ;(window as any)[callbackName] = (data: T) => {
    callback(null, data)
    // Cleanup
    document.head.removeChild(script)
    delete (window as any)[callbackName]
  }

  // Handle errors
  script.onerror = () => {
    callback(new Error('JSONP request failed'))
    // Cleanup
    document.head.removeChild(script)
    delete (window as any)[callbackName]
  }

  // Set script source with callback parameter
  script.src = `${url}&${options.param}=${callbackName}`
  document.head.appendChild(script)
}
